import { PromoRollSynthJobFieldsFragment } from '@entities/PromoRollSynthJob/model';
import { PromoUploadStatusType } from '@entities/adCampaign';

export const convertJobToPromoStatus = (job: PromoRollSynthJobFieldsFragment): PromoUploadStatusType => ({
  id: job.id,
  promoId: job.promoMediafile?.id,
  title: job.title,
  filename: job.promoMediafile?.filename,
  duration: job.promoMediafile?.duration,
  previewUrl: job.promoMediafile?.previewUrl,
  sourcefiles: job.promoMediafile?.sourcefiles ?? [],
  isLoading: false,
});

export const convertJobsToPromoStatuses = (jobs: PromoRollSynthJobFieldsFragment[]): PromoUploadStatusType[] =>
  jobs.map(convertJobToPromoStatus);
